// web-common/src/dismiss-core.js — the PURE outside-click/Escape controller (D-AUTH §6).
// No imports, no React — the suites drive it with a fake document (dismiss.test.js); the
// React wrapper lives in dismiss.js. pointerdown (not click) so the menu closes before a
// click lands elsewhere — and so selecting text inside doesn't dismiss halfway through.

export function makeDismissController(doc, isInside, onClose) {
  const onPointerDown = (e) => { if (!isInside(e.target)) onClose(e); };
  const onKeyDown = (e) => { if (e.key === 'Escape') onClose(e); };
  doc.addEventListener('pointerdown', onPointerDown, true); // capture: fires even when a target stops propagation
  doc.addEventListener('keydown', onKeyDown, true);
  return function detach() {
    doc.removeEventListener('pointerdown', onPointerDown, true);
    doc.removeEventListener('keydown', onKeyDown, true);
  };
}
